export default "__VITE_ASSET__bc1066ea__"